import { useMediaQuery } from "@mui/material";
import { Storage } from "@capacitor/storage";
import status from "http-status";

/** ¿Respuesta correcta? Las acciones devuelven el código HTTP (el interceptor convierte los errores en su código). */
export const isSuccess = (response) => status[`${response}_CLASS`] === status.classes.SUCCESSFUL;

/** Quita mayúsculas y acentos para buscar. */
export const normalizeText = (value) =>
	String(value ?? "")
		.normalize("NFD")
		.replace(/[̀-ͯ]/g, "")
		.toLowerCase();

const MOBILE_QUERY = "(max-width:900px)";
export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);

// COOKIES
export const setCookie = async (key, value) => {
	await Storage.set({ key, value: JSON.stringify(value) });
};

export const getCookie = async (key) => {
	const c = await Storage.get({ key });
	return JSON.parse(c.value);
};

export const deleteCookie = async (key) => {
	await Storage.remove({ key });
};

export const toBase64 = (file) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});

export const copyToClipboard = async (text) => {
	if (navigator.clipboard && window.isSecureContext) {
		await navigator.clipboard.writeText(text);
		return;
	}

	const textArea = document.createElement("textarea");
	textArea.value = text;
	textArea.style.position = "fixed";
	textArea.style.left = "-9999px";
	document.body.appendChild(textArea);
	textArea.select();
	document.execCommand("copy");
	textArea.remove();
};
